import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, exhaustMap, catchError, tap} from 'rxjs/operators';

import {AuthService} from '../services/auth.service';
import {
  RetrieveUserSuccessful,
  RetrieveProjectsSuccessful,
  RetrieveUser,
  Logout,
  RetrieveProjects,
  ProjectSettings,
  RetrieveVaEnableStatus, RetrieveVaEnableStatusSuccess
} from '../actions/auth';
import {Constants} from '../../shared/constants';
import {UpdateRegionInfo} from '../../actions/region.action';
import {ServiceRegion} from '../../../../common/constants';

@Injectable()
export class AuthEffects {

  getUser = createEffect(() => this.actions.pipe(
    ofType(RetrieveUser),
    exhaustMap(() => this.authService.retrieveUser()
      .pipe(
        catchError(error => this.authService.handleAuthError(error)),
        map(userProfile => RetrieveUserSuccessful(userProfile))
      ))
  ));

  logOut = createEffect(() => this.actions.pipe(
    ofType(Logout),
    tap(() => this.authService.logout())
  ), {dispatch: false});

  getProjects = createEffect(() => this.actions.pipe(
    ofType(RetrieveProjects),
    exhaustMap(() => this.authService.retrieveProjects()
      .pipe(
        map(projects => RetrieveProjectsSuccessful(projects))
      ))
  ));

  projectSettings = createEffect(() => this.actions.pipe(
    ofType(ProjectSettings),
    map(({projectSettings}) => {
      const {serviceRegion = ServiceRegion.USA} = projectSettings;
      const selectedRegionInfo = Constants.RegionDetails.RegionDetails[serviceRegion];
      return UpdateRegionInfo(selectedRegionInfo);
    })
  ));

  loadVaEnableStatus$ = createEffect(() =>
    this.actions.pipe(
      ofType(RetrieveVaEnableStatus),
      exhaustMap(({clientId}) =>
        this.authService.RetrieveVaConfig(clientId).pipe(
          map((response: boolean) => RetrieveVaEnableStatusSuccess(response))
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    private authService: AuthService,
  ) {
  }

}
